/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelTipoPraticaIstitutoDTO } from '../model/models';
import { TipoPraticaIstitutoCreationForm } from '../model/models';
import { TipoPraticaIstitutoDTO } from '../model/models';
import { TipoPraticaIstitutoListFilter } from '../model/models';
import { TipoPraticaIstitutoPatchForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreateTipoPraticaIstitutoRequestParams {
    idTipoPratica: string;
    tipoPraticaIstitutoCreationForm: TipoPraticaIstitutoCreationForm;
}

export interface DeleteTipoPraticaIstitutoRequestParams {
    idTipoPratica: string;
    idIstituto: string;
}

export interface GetTipoPraticaIstitutoRequestParams {
    idTipoPratica: string;
    idIstituto: string;
}

export interface ListTipoPraticaIstitutiRequestParams {
    idTipoPratica: string;
    filter: TipoPraticaIstitutoListFilter;
    pageable: Pageable;
}

export interface UpdateTipoPraticaIstitutoRequestParams {
    idTipoPratica: string;
    idIstituto: string;
    tipoPraticaIstitutoPatchForm: TipoPraticaIstitutoPatchForm;
}


export interface TipoPraticaIstitutoControllerServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Crea un nuovo Istituto per il TipoPratica
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti
* @param requestParameters
     */
    createTipoPraticaIstituto(requestParameters: CreateTipoPraticaIstitutoRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaIstitutoDTO>;

    /**
     * Elimina un Istituto (cascade su Plessi e Assegnazioni)
     * 
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}
* @param requestParameters
     */
    deleteTipoPraticaIstituto(requestParameters: DeleteTipoPraticaIstitutoRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Dettaglio di un Istituto per id
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}
* @param requestParameters
     */
    getTipoPraticaIstituto(requestParameters: GetTipoPraticaIstitutoRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaIstitutoDTO>;

    /**
     * Lista paginata degli Istituti del TipoPratica (filtri: nome, codice_meccanografico, attivo, q)
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti
* @param requestParameters
     */
    listTipoPraticaIstituti(requestParameters: ListTipoPraticaIstitutiRequestParams, extraHttpRequestParams?: any): Observable<PagedModelTipoPraticaIstitutoDTO>;

    /**
     * Replace di un Istituto (richiede version per optimistic lock)
     * 
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}
* @param requestParameters
     */
    updateTipoPraticaIstituto(requestParameters: UpdateTipoPraticaIstitutoRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaIstitutoDTO>;

}
